import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceProjectsTransferNotificationState = createStateReducer(
  initialState,
  {
    [events.transferProjectsSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "transferProjects",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.transferProjectsFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "transferProjects",
          flags: ["failure"],
          args: { failure: "true", message: error.message },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceProjectsTransferNotificationState };
